import { takeLatest } from 'redux-saga/effects';
import {
  DELETE_MAPPING_REQUEST,
  FETCH_ADD_RETURN_DATA_REQUEST,
  SAVE_MAPPING_REQUEST,
  FETCH_RETURN_TYPES_REQUEST,
  FETCH_DEFAULT_TAX_RATES_REQUEST,
  MAP_TAX_RATES_TO_BOXES,
} from '../constants';
import { fetchAddReturnDataSaga } from './fetchAddReturnDataSaga';
import { saveMappingSaga } from './saveMappingSaga';
import { deleteMappingSaga } from './deleteMappingSaga';
import { fetchReturnTypesSaga } from './fetchReturnTypesSaga';
import { fetchDefaultTaxRatesSaga } from './fetchDefaultTaxRatesSaga';
import { mapTaxRatesToBoxesSaga } from './mapTaxRatesToBoxesSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* returnSaga() {
  yield takeLatest(FETCH_ADD_RETURN_DATA_REQUEST, fetchAddReturnDataSaga);
  yield takeLatest(SAVE_MAPPING_REQUEST, saveMappingSaga);
  yield takeLatest(DELETE_MAPPING_REQUEST, deleteMappingSaga);
  yield takeLatest(FETCH_RETURN_TYPES_REQUEST, fetchReturnTypesSaga);
  yield takeLatest(FETCH_DEFAULT_TAX_RATES_REQUEST, fetchDefaultTaxRatesSaga);
  yield takeLatest(MAP_TAX_RATES_TO_BOXES, mapTaxRatesToBoxesSaga);
}
